export const SET_USER_PROFILE_FORM = 'SET_USER_PROFILE_FORM';

export function setUserProfileForm(name, value) {
  return {
    type: SET_USER_PROFILE_FORM,
    payload: {name, value},
  };
}



// WEBPACK FOOTER //
// ./app/features/userProfile/actions/setUserProfileForm.js